export default (that) => [
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox'
  },
  {
    title: that.$l('package_label_materialName') || '包装中文名',
    field: 'materialName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('package_label_materialNameEn') || '包装英文名',
    field: 'materialNameEn',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('package_label_qty') || '数量',
    field: 'qty',
    width: 150,
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        max: 100,
        min: 1,
        step: 1,
        stepStrictly: true
      },
      placeholder: that.$l('tips_package_label_qty') || '请输入数量',
      immediate: true
    }
  }
]
